import { InfoWindowF, MarkerF } from "@react-google-maps/api";
import { Location } from "~/api/resources/Events";
import { getMarkerIcon, getPositionFromLonLat } from "../helpers";
import { Link, Stack, Text } from "@chakra-ui/react";
import { useState } from "react";

type Props = {
  location: Location;
};
export const LocationMarker = ({ location }: Props) => {
  const { name, full_address, phone_number, website } = location;
  const position = location.lonlat
    ? getPositionFromLonLat(location.lonlat)
    : null;
  const [focused, setFocused] = useState(false);
  if (!position) return null;
  return (
    <MarkerF
      key={location.id}
      position={position}
      icon={getMarkerIcon()}
      onClick={() => setFocused((f) => !f)}
    >
      {focused && (
        <InfoWindowF onCloseClick={() => setFocused(false)}>
          <Stack>
            <Text textStyle="displayXS">{name}</Text>
            {full_address && <Text textStyle="p3">{full_address}</Text>}
            {phone_number && <Text textStyle="p3">{phone_number}</Text>}
            {website && (
              <Link href={website} target="_blank">
                {website}
              </Link>
            )}
          </Stack>
        </InfoWindowF>
      )}
    </MarkerF>
  );
};
